<template>
  <div class="floating-messenger-container" v-if="showButton">
    <router-link to="/messenger" class="floating-messenger-button">
      <span class="messenger-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.477 2 2 6.145 2 11.259c0 2.913 1.454 5.512 3.726 7.21V22l3.405-1.869c.909.252 1.871.388 2.869.388 5.523 0 10-4.145 10-9.259S17.523 2 12 2zm1.016 12.471l-2.548-2.717-4.973 2.717 5.475-5.812 2.609 2.717 4.912-2.717-5.475 5.812z"/>
        </svg>
      </span>
      <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount }}</span>
    </router-link>
  </div>
</template>

<script>
import { DashboardService } from '@/services/dashboard'

export default {
  name: 'FloatingMessengerButton',
  data () {
    return {
      unreadCount: 0,
      isConnected: false,
      interval: null,
      showButton: false
    }
  },
  mounted () {
    this.init()
    window.addEventListener('resize', this.updateVisibility)
    this.interval = setInterval(() => this.fetchUnreadCount(), 30000)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.updateVisibility)
    if (this.interval) clearInterval(this.interval)
  },
  methods: {
    isAdmin () {
      return !localStorage.getItem('agent_token')
    },
    async init () {
      if (!this.isAdmin()) return
      try {
        const result = await DashboardService.getMessengerPages()
        this.isConnected = result.success && result.pages && result.pages.length > 0
        if (this.isConnected) await this.fetchUnreadCount()
        else this.updateVisibility()
      } catch (e) {
        this.isConnected = false
      }
    },
    updateVisibility () {
      const isMobile = window.innerWidth <= 768
      this.showButton = this.isConnected && (isMobile || this.unreadCount > 0)
    },
    async fetchUnreadCount () {
      try {
        const result = await DashboardService.getMessengerUnreadCount()
        if (result.success) {
          this.unreadCount = result.unreadCount || 0
          this.updateVisibility()
        }
      } catch (e) {}
    }
  }
}
</script>

<style scoped>
.floating-messenger-container {
  position: fixed;
  bottom: 96px;
  right: 24px;
  z-index: 1000;
}

.floating-messenger-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #8A3FFC 0%, #006AFF 100%);
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(0, 106, 255, 0.4);
  color: white;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;
  animation: pulse-glow 2s infinite;
}

.floating-messenger-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(0, 106, 255, 0.6);
}

.floating-messenger-button:active {
  transform: scale(0.95);
}

.messenger-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.unread-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.4);
  animation: badge-pulse 2s infinite;
}

@keyframes pulse-glow {
  0%, 100% { box-shadow: 0 4px 16px rgba(0, 106, 255, 0.4); }
  50%       { box-shadow: 0 4px 24px rgba(0, 106, 255, 0.6); }
}

@keyframes badge-pulse {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.1); }
}

@media (max-width: 480px) {
  .floating-messenger-container {
    bottom: 148px;
    right: 20px;
  }

  .floating-messenger-button {
    width: 56px;
    height: 56px;
  }

  .messenger-icon svg {
    width: 26px;
    height: 26px;
  }
}
</style>
